// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__HSC7C","link":"Footer_link__2EC6d"};